import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { StepProps } from '../../types/journey';
import {
   API_ENDPOINTS,
   customToast,
   FormInput,
   route,
   StringHelpers,
   SubTitle,
   useDisabledContext,
   Variants,
   Stepper,
   useLangContext,
   DateFormats,
} from 'carrier-fe';
import axios from 'axios';
import { InstallationFormData } from '../../pages/installation/journey';
import { useParams, useSearchParams } from 'react-router-dom';
import { STEPS, SYSTEM_TYPES } from '../../util/Constants';
import { format } from 'date-fns';

const Section = ({ children }: { children: React.ReactNode }) => {
   return <div className="mb-4">{children}</div>;
};

function Step3({ form, loading, stepLang }: StepProps) {
   const { store, setValues, errors, } = form;
   const { crud, fields } = useLangContext();
   const { setDisabled, disabled } = useDisabledContext();
   const [isLoading, setIsLoading] = React.useState(false);
   const [showGasSafeFields, setShowGasSafeFields] = useState(
      form?.store?.system_type === SYSTEM_TYPES.GAS_BOILER
   );
   const [searchParams] = useSearchParams();
   const urlParams = useParams();
   const installationId =
      searchParams.get('installationId') || urlParams?.installationId;

   useLayoutEffect(() => {
      if (!store?.system_type || store?.system_type === '') {
         setIsLoading(true);
         setDisabled(true);
         getStepData(STEPS.STEP_2);
      }
   }, []);

   const getStepData = async (step: number) => {
      try {
         const response = await axios.get<{
            data: Partial<InstallationFormData>;
            message: string;
         }>(
            route(API_ENDPOINTS.REGISTRATION.INSTALLATION.EDIT, {
               installationId:
                  installationId ||
                  searchParams.get('installationId') ||
                  '',
               step: String(step),
            })
         );

         setValues({ system_type: response?.data?.data?.system_type });
         setShowGasSafeFields(
            response?.data?.data?.system_type === SYSTEM_TYPES.GAS_BOILER
         );
      } catch (error: any) {
         customToast({
            title: error?.response?.data?.message,
            variant: Variants.Danger,
         });
      } finally {
         setIsLoading(false);
         setDisabled(false);
      }
   };

   return (
      <Stepper.Step
         loading={loading || isLoading}
         title={stepLang?.title}

      >
         <Section>
            <SubTitle
               title={StringHelpers.title(
                  crud?.sub_titles?.details || 'Details'
               )}
               className="mb-3 w-100"
               style={{ color: '#464C5E' }}
            />
            <FormInput
               type="date"
               name="completion_date"
               label={StringHelpers.title(
                  fields?.completion_date || 'Work Completion Date'
               )}
               value={store?.completion_date}
               onChange={(value) =>
                  setValues({
                     completion_date: value as string,
                  })
               }
               errorMessages={errors?.completion_date}
               disabled={disabled}
            />
         </Section>

      </Stepper.Step>
   );
}

export default Step3;
